import {
  IServiceAuditRunStageRow,
  ServiceAuditRunStatusHelper,
} from '../helpers/ServiceAuditRunStatusHelper';
import { ServiceAuditRunStageIcon } from './ServiceAuditRunStageIcon';

interface IServiceAuditRunStageListProps {
  runStageRows: ReadonlyArray<IServiceAuditRunStageRow>;
}

/** The auditor's four stages in fixed order, announced politely as they change. */
export const ServiceAuditRunStageList = ({
  runStageRows,
}: IServiceAuditRunStageListProps) => (
  <ol aria-live="polite" className="flex flex-col gap-md">
    {runStageRows.map((row) => (
      <li key={row.name} className="flex items-start gap-xs">
        <span className="flex shrink-0 items-center" aria-hidden="true">
          <ServiceAuditRunStageIcon status={row.status} />
        </span>
        <span className="sr-only">
          {ServiceAuditRunStatusHelper.STAGE_STATUS_WORDS[row.status]}
        </span>
        <div className="flex min-w-0 flex-col">
          <span className="txt-small-medium text-text-primary">
            {row.label}
          </span>
          {row.detail && (
            <span className="txt-extra-small-regular break-words text-text-tertiary">
              {row.detail}
            </span>
          )}
        </div>
      </li>
    ))}
  </ol>
);
